// extracted by mini-css-extract-plugin
module.exports = {"loading-receipt":"XO3QVSJRusEO6pViHyPG8","load-billing-receipt":"_1s0oqqEZMzkmHhQJgGIWrw","billing-section":"_3cLcy8b65JjndAlGcfoMtk"};